import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  PAYMENT_SERVICE_CALLBACK_PATH,
  PAYMENT_SERVICE_PAYMENT_OPTIONS_PATH,
  PAYMENT_SERVICE_PUBLIC_PAYMENT_OPTIONS_PATH,
  PAYMENT_SERVICE_SUMMARY_PATH,
  PAYMENT_SERVICE_SUMMARY_PUBLIC_PATH,
  PAYMENT_SERVICE_TOKENIZATION_CALLBACK_PATH,
  PAYMENT_SERVICE_TOKENIZATION_MANAGE_PATH,
  PAYMENT_SERVICE_TOKENIZATION_PATH,
  PAYMENT_SERVICE_TOKENIZATION_STATUS_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const PaymentSummaryPage = lazy(() => import('./pages/PaymentSummaryPage/PaymentSummaryPage'));
const PaymentOptionsPage = lazy(() => import('./pages/PaymentOptionsPage/PaymentOptionsPage'));
const PaymentCallbackPage = lazy(() => import('./pages/PaymentCallbackPage/PaymentCallbackPage'));
const PaymentTokenizationPage = lazy(() => import('./pages/PaymentTokenizationPage/PaymentTokenizationPage'));
const PaymentTokenizationCallbackPage = lazy(
  () => import('./pages/PaymentTokenizationCallbackPage/PaymentTokenizationCallbackPage')
);
const PaymentTokenizationStatusPage = lazy(
  () => import('./pages/PaymentTokenizationStatusPage/PaymentTokenizationStatusPage')
);
const PaymentTokenizationManagePage = lazy(
  () => import('./pages/PaymentTokenizationManagePage/PaymentTokenizationManagePage')
);

export const PAYMENT_SERVICE_ROUTES: RouteConfig[] = [
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <PaymentSummaryPage isSingpass />,
    displayTitle: () => 'Bills & Payments',
    isNavHeaderHide: true,
    pageType: PageType.PRIVATE,
    path: PAYMENT_SERVICE_SUMMARY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.payment,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <PaymentSummaryPage />,
    displayTitle: () => 'Bills & Payments',
    isNavHeaderHide: true,
    layoutProps: {
      contentClassName: 'lg:max-w-5xl',
    },
    pageType: PageType.PUBLIC,
    path: PAYMENT_SERVICE_SUMMARY_PUBLIC_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.publicPayment,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <PaymentOptionsPage isSingpass />,
    displayTitle: () => 'Bills & Payments',
    pageType: PageType.PRIVATE,
    path: PAYMENT_SERVICE_PAYMENT_OPTIONS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.payment,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <PaymentOptionsPage />,
    displayTitle: () => 'Bills & Payments',
    layoutProps: {
      contentClassName: 'lg:max-w-5xl',
    },
    pageType: PageType.PUBLIC,
    path: PAYMENT_SERVICE_PUBLIC_PAYMENT_OPTIONS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.publicPayment,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <PaymentCallbackPage />,
    displayTitle: () => 'Bills & Payments',
    isHideBackNavButton: true,
    layoutProps: {
      contentClassName: 'lg:max-w-5xl',
    },
    pageType: PageType.PUBLIC,
    path: PAYMENT_SERVICE_CALLBACK_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.publicPayment,
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <PaymentTokenizationPage />,
    displayTitle: () => 'Linked Payment Method',
    layoutProps: {
      contentClassName: 'lg:max-w-5xl',
    },
    pageType: PageType.PRIVATE,
    path: PAYMENT_SERVICE_TOKENIZATION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.payment,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <PaymentTokenizationCallbackPage />,
    displayTitle: () => 'Linked Payment Method',
    isHideBackNavButton: true,
    layoutProps: {
      contentClassName: 'lg:max-w-5xl',
    },
    pageType: PageType.PUBLIC,
    path: PAYMENT_SERVICE_TOKENIZATION_CALLBACK_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.publicPayment,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <PaymentTokenizationStatusPage />,
    displayTitle: () => 'Add New Card',
    layoutProps: {
      contentClassName: 'lg:max-w-5xl',
    },
    pageType: PageType.PRIVATE,
    path: PAYMENT_SERVICE_TOKENIZATION_STATUS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.payment,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <PaymentTokenizationManagePage />,
    displayTitle: () => 'Manage Card',
    layoutProps: {
      contentClassName: 'lg:max-w-5xl',
    },
    pageType: PageType.PRIVATE,
    path: PAYMENT_SERVICE_TOKENIZATION_MANAGE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.payment,
  },
];
